import React, { useState, useEffect } from 'react';

import { WarningText, KeyContainer, ButtonsWrapper } from '../styledComponents';
import SmallButtonStyled from '../../../components/Buttons/SmallButtonStyled';
import { ModalHeaderWrapper } from '../styledComponents';
import BaseModal from '../../../components/BaseModal';
import doFetch from '../../../api/doFetch';

export default function ApiKeyModal({ isOpen, onClose, partner, reloadPartners }) {
  const [isCopied, setIsCopied] = useState(false);
  const [newApiKey, setNewApiKey] = useState(null);
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    if (isOpen) generateKey();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const generateKey = async () => {
    try {
      const url = `/lotlenz/partners/${partner.id}/keys`;
      const result = await doFetch(url, { method: 'POST' });

      if (result?.key) {
        setNewApiKey(result.key);
        setUpdated(true);
      }
    } catch (error) {
      console.error('Error generating key:', error);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(newApiKey);
      setIsCopied(true);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCloseOrBack = () => {
    reloadPartners();
    onClose();
  };

  return (
    <BaseModal
      isOpen={isOpen}
      toggleHandler={handleCloseOrBack}
      header={<ModalHeaderWrapper>YOUR NEW API KEY</ModalHeaderWrapper>}
    >
      {updated ? (
        <>
          <WarningText>
            Please copy your API key now. <br />
            For security reasons, it is stored encrypted and cannot be displayed again after you
            close this window!
          </WarningText>

          <KeyContainer>{newApiKey}</KeyContainer>

          <ButtonsWrapper>
            <SmallButtonStyled type='button' onClick={handleCopy}>
              {isCopied ? 'Copied!' : 'Copy to clipboard'}
            </SmallButtonStyled>

            <SmallButtonStyled type='button' onClick={handleCloseOrBack} disabled={!isCopied}>
              I have copied it, go back
            </SmallButtonStyled>
          </ButtonsWrapper>
        </>
      ) : (
        <div style={{ minWidth: 356, minHeight: 229 }}></div>
      )}
    </BaseModal>
  );
}
